import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from '@gasbuddy/react-components';
import MagicLinkSent from '../MagicLinkSent';
import LoginCodeEntry from '../LoginCodeEntry';
import { MagicLinkStatus } from '../../reducers/magiclinks';

export default function MagicLinkButton({ deviceLabel, useCode, variant, ...rest }) {
  const { t } = useTranslation('auth');

  return (
    <React.Fragment>
      <Modal
        content={() => (
          useCode ? (
            <LoginCodeEntry
              variant={variant}
              deviceLabel={deviceLabel}
            />
          ) : (
            <MagicLinkSent
              variant={variant}
              deviceLabel={deviceLabel}
            />
          )
        )}
        forceIsShowing={!!variant}
        size="sm"
      />
      <Button
        fluid
        secondary
        type="submit"
        {...rest}
      >
        {useCode ? t('magicLinkButton.emailCode') : t('magicLinkButton.emailLink')}
      </Button>
    </React.Fragment>
  );
}

MagicLinkButton.propTypes = {
  deviceLabel: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(MagicLinkStatus)),
  useCode: PropTypes.bool,
};

MagicLinkButton.defaultProps = {
  deviceLabel: undefined,
  variant: undefined,
  useCode: false,
};
